import React, { useEffect,useState,useMemo } from "react";
import { Context,Hooks,Util,XtLocale } from "@xt/xtbase";
const {XtContext} = Context;
const {useTranslation,Trans} = Hooks;
const {getUrl,moment,Big} = Util;
moment.locale("en")
import styles from "./index.module.less";
import { useStore } from '@/models';
import { observer } from 'mobx-react-lite';
import { Modal,message,Checkbox,Progress,Drawer } from "antd";
import closePng from "@/assets/images/home/closePng.png";
import DurationSelect from "../DurationSelect";
import Countdown from "../_cmpt/Countdown";
import SvgIcon from "@xt/SvgIcon";
import StarSvg from "@/assets/icon-svg/finance/star.svg";
import WhitepaperSvg from "@/assets/icon-svg/finance/whitepaper.svg";
import WebsiteSvg from "@/assets/icon-svg/finance/website.svg";
import RulesSvg from "@/assets/icon-svg/finance/rules.svg";
import { post_order,get_productPosition,get_product_by_id,get_productSubscribed } from '@/api/v4/finance';
import getProductStatus from "@/components/Pages/Finance/_hook/getProductStatus";
import AutoSubscribe from "../AutoSubscribe";
import hot from "@/assets/images/finance/hot.png";
import gou from "@/assets/icon-svg/finance/gou.svg";
import checkSvg from "@/assets/icon-svg/finance/check.svg";
import check2 from "@/assets/images/finance/check2.png";
import check3 from "@/assets/images/finance/check3.png";
import buy1Svg from "@/assets/icon-svg/finance/buy1.svg";
import buy2Svg from "@/assets/icon-svg/finance/buy2.svg";
import buy3Svg from "@/assets/icon-svg/finance/buy3.svg";
import ArrowSvg from "@/assets/icon-svg/finance/arrow.svg";
import subok from "@/assets/images/finance/subok.png";
import InfoTip from "../InfoTip";
import useProductChange from "components/Pages/Finance/_hook/useProductChange";
import XtFontScale from "@/components/Xt/fontScale";

export default observer(() => {
  const t = useTranslation();
  const { fund,finance,app } = useStore();
  const [appState] = React.useContext(XtContext);

  const [status, setStatus] = useState(0);
  const [showStakingAmount, setShowStakingAmount] = useState(0);
  const [currentProduct, setCurrentProduct] = useState(null);
  const [financialProducts, setFinancialProducts] = useState([]);
  const [inputStatus, setInputStatus] = useState(0);
  const [inputTip, setInputTip] = useState("");
  const [amountValue, setAmountValue] = useState("");
  const [amountValue2, setAmountValue2] = useState("");
  const [protocolChecked, setProtocolChecked] = useState(false);
  const [position, setPostiton] = useState(0);
  const [subscribed, setSubscribed] = useState(0);
  const [currentDate, setCurrentDate] = useState(new Date().getUTCDate());
  const [btnPosting, setBtnPosting] = useState(false);
  const [postTime, setPostTime] = useState(0);
  const [showDrawer, setShowDrawer] = useState(true);

  useEffect(()=>{
    var inteval = setInterval(()=>{
      var d = new Date().getUTCDate();
      if(d != currentDate)
      {
        setCurrentDate(d);
      }
    },1000);
    return ()=>{
      clearInterval(inteval);
    }
  },[]);

  useEffect(()=>{
    if(appState.loginStatus == 1)
      fund.fetchBalances();
  },[appState.loginStatus]);

  useEffect(()=>{
    setAmountValue("");
    setAmountValue2("");
    setInputStatus(0);
    setInputTip("");
    setProtocolChecked(false);
    if(currentProduct)
    {
      get_productPosition({params:{productId:currentProduct.id}}).then((data)=>{
        setPostiton(parseFloat(data || "0"));
      });
      get_productSubscribed({params:{productId:currentProduct.id}}).then((data)=>{
        setSubscribed(parseFloat(data || "0"));
      });
    }
  },[currentProduct]);
  
  useEffect(()=>{
    if(finance.showSubscribe && finance.showSubscribe.financialProducts)
    {
      for (var key in finance.showSubscribe.financialProducts) {
        if (finance.showSubscribe.financialProducts[key].id == finance.showSubscribe.productId) {
          setCurrentProduct(finance.showSubscribe.financialProducts[key]);
          break;
        }
      }
      setFinancialProducts(finance.showSubscribe.financialProducts);
    }
    else
      setCurrentProduct(null);
  },[finance.showSubscribe]);

  const memoExpectProfit = useMemo(()=>{
    if(!currentProduct)
      return 0;
    const amount = amountValue == "" ? 0 : parseFloat(amountValue);
    if(currentProduct.productType == "LAUNCH_POOL")
    {
      const r = currentProduct.totalReward * currentProduct.rewardPercent / 100 / (currentProduct.duration || 1);
      return (new Big(r*amount/currentProduct.totalQuota)).toFixed(fund.getCurrencyPrecision(currentProduct.interestCurrency));
    }
    else if(currentProduct.productType == "HASH_RATE")
    {
      var p = (1-currentProduct.managementFee/100);
      var min = p*currentProduct.dailyMinOutput*amount/currentProduct.totalQuota;
      var max = p*currentProduct.dailyMaxOutput*amount/currentProduct.totalQuota;
      return new Big(min).toFixed(fund.getCurrencyPrecision(currentProduct.interestCurrency))+" ~ "+new Big(max).toFixed(fund.getCurrencyPrecision(currentProduct.interestCurrency));
    }
    if(currentProduct.profitType == "GRADING")
    {
      if(currentProduct.apyList && currentProduct.apyList.length)
      {
        var ret = 0;
        var total = position;
        var left = amount;
        for(var i=0;i<currentProduct.apyList.length;++i)
        {
          if(left <= 0)
            break;
          var item = currentProduct.apyList[i];
          var annualized = item.annualized || 0;
          if(total > item.level)
            continue;
          var d = Math.min(item.level - total, left);
          total += d;
          left -= d;
          if(currentProduct.productType == "DEMAND_SAVING")
          {
            ret += (d*annualized/100/365);
          }
          else
          {
            if(currentProduct.interestReinvest)
              ret += (d*Math.pow(1+annualized/100/365,currentProduct.duration)-d);
            else
              ret += (d*annualized/100*currentProduct.duration/365);
          }
        }
        if(left > 0)
        {
          var annualized = currentProduct.apyList[currentProduct.apyList.length-1].annualized || 0;
          if(currentProduct.productType == "DEMAND_SAVING")
          {
            ret += (left*annualized/100/365);
          }
          else
          {
            if(currentProduct.interestReinvest)
              ret += (left*Math.pow(1+annualized/100/365,currentProduct.duration)-left);
            else
              ret += (left*annualized/100*currentProduct.duration/365);
          }
        }
        return new Big(ret).toFixed(fund.getCurrencyPrecision(currentProduct.interestCurrency));
      }
      else
        return 0;
    }
    else
    {
      if(currentProduct.apyList && currentProduct.apyList.length && currentProduct.apyList[0].annualized)
      {
        if(currentProduct.productType == "DEMAND_SAVING")
        {
          return new Big((amount*currentProduct.apyList[0].annualized/100)/365).toFixed(fund.getCurrencyPrecision(currentProduct.interestCurrency));
        }
        else
        {
          if(currentProduct.interestReinvest)
            return new Big(amount*Math.pow(1+currentProduct.apyList[0].annualized/100/365,currentProduct.duration)-amount).toFixed(fund.getCurrencyPrecision(currentProduct.interestCurrency));
          else
            return new Big(amount*(currentProduct.apyList[0].annualized/100)*currentProduct.duration/365).toFixed(fund.getCurrencyPrecision(currentProduct.interestCurrency));
        }
      }
      else
        return 0;
    }
  },[currentProduct,amountValue,position]);

  const memoTimes = useMemo(()=>{
    if(!currentProduct)
      return {};
    var s = parseInt(new Date().getTime()/1000);
    s -= s % 86400;
    s *= 1000;
    if(currentProduct.productType == "DEMAND_SAVING")
    {
      return {
        time2:moment(s+86400000).format("YYYY-MM-DD HH:mm:ss"),
        time3:moment(s+86400000*2).format("YYYY-MM-DD HH:mm:ss"),
      }
    }
    else if(currentProduct.productType == "TIME_SAVING")
    {
      return {
        time2:moment(s+86400000).format("YYYY-MM-DD HH:mm:ss"),
        time3:moment(s+86400000*2).format("YYYY-MM-DD HH:mm:ss"),
        time4:moment(s+86400000*(currentProduct.duration+1)).format("YYYY-MM-DD HH:mm:ss"),
        time5:moment(s+86400000*(currentProduct.duration+1)+14400000).format("YYYY-MM-DD HH:mm:ss"),
      }
    }
    else if(currentProduct.productType == "RUSH")
    {
      var s1 = parseInt(currentProduct.workStartTime/1000);
      s1 -= s1 % 86400;
      s1 *= 1000;
      var s2 = parseInt(currentProduct.workEndTime/1000);
      s2 -= s2 % 86400;
      s2 *= 1000;
      return {
        time2:moment(currentProduct.workStartTime).format("YYYY-MM-DD HH:mm:ss"),
        time3:moment(s1+86400000).format("YYYY-MM-DD HH:mm:ss"),
        time4:moment(currentProduct.workEndTime).format("YYYY-MM-DD HH:mm:ss"),
        time5:moment(currentProduct.workEndTime+14400000).format("YYYY-MM-DD HH:mm:ss"),
      }
    }
    else if(currentProduct.productType == "LAUNCH_POOL")
    {
      var s0 = new Date().getTime() > currentProduct.workStartTime ? s : currentProduct.workStartTime;
      var s1 = parseInt(s0/1000);
      s1 -= s1 % 86400;
      s1 *= 1000;
      var s2 = parseInt(currentProduct.workEndTime/1000);
      s2 -= s2 % 86400;
      s2 *= 1000;
      return {
        time2:moment(s0).format("YYYY-MM-DD HH:mm:SS"),
        time3:moment(s1+86400000).format("YYYY-MM-DD HH:mm:SS"),
        time4:moment(currentProduct.workEndTime).format("YYYY-MM-DD HH:mm:ss"),
        time5:moment(currentProduct.workEndTime+14400000).format("YYYY-MM-DD HH:mm:ss"),
      }
    }
    else if(currentProduct.productType == "POS_STAKING")
    {
      var s2 = parseInt(currentProduct.subscribeEndTime/1000);
      s2 -= s2 % 86400;
      s2 *= 1000;
      return {
        time2:moment(s+86400000).format("YYYY-MM-DD HH:mm:SS"),
        time3:moment(s+86400000*2).format("YYYY-MM-DD HH:mm:SS"),
        time4:moment(s+86400000*(currentProduct.duration+1)).format("YYYY-MM-DD HH:mm:ss"),
        time5:moment(s+86400000*(currentProduct.duration+1)+14400000).format("YYYY-MM-DD HH:mm:ss"),
      }
    }
    else if(currentProduct.productType == "HASH_RATE")
    {
      var s1 = parseInt(currentProduct.workStartTime/1000);
      s1 -= s1 % 86400;
      s1 *= 1000;
      var s2 = parseInt(currentProduct.workEndTime/1000);
      s2 -= s2 % 86400;
      s2 *= 1000;
      return {
        time2:moment(currentProduct.workStartTime).format("YYYY-MM-DD HH:mm:ss"),
        time3:moment(s1+86400000).format("YYYY-MM-DD HH:mm:ss"),
        time4:moment(currentProduct.workEndTime).format("YYYY-MM-DD HH:mm:ss")
      }
    }
  },[currentProduct, currentDate]);

  const memoLimit = useMemo(()=>{
    if(!currentProduct)
      return 0;
    if(currentProduct.totalQuota <= 0)
    {
      if(!currentProduct.individualCap || currentProduct.individualCap <= 0)
        return -1;
      else
        return Math.max(0,currentProduct.individualCap - position);
    }
    else
    {
      if(!currentProduct.individualCap || currentProduct.individualCap <= 0)
        return Math.max(0,currentProduct.totalQuota - subscribed);
      else
        return Math.max(0,Math.min(currentProduct.totalQuota - subscribed,currentProduct.individualCap - position));
    }
  },[currentProduct,position,subscribed]);

  const onChangeProduct = useProductChange((s) => {
    setCurrentProduct(s);
  });

  if(!currentProduct)
    return <></>
  
  var {productType,currency,singleMin,singleMax,interestCurrency} = currentProduct;
  currency = (currency || "").toUpperCase();
  interestCurrency = (interestCurrency || "").toUpperCase();

  var currencyPrecision = currentProduct.currencyPrecision || fund.getCurrencyPrecision(currency);

  const CATEGORYS = {
    "DEMAND_SAVING":{title:"finance.subscribeTitle1",titleH5:"finance.flexible"},
    "TIME_SAVING":{title:"finance.subscribeTitle2",titleH5:"finance.fixed"},
    "RUSH":{title:"finance.subscribeTitle3",titleH5:"finance.promotions"},
    "LAUNCH_POOL":{title:"finance.subscribeTitle4",titleH5:"finance.Launchpool"},
    "POS_STAKING":{title:"finance.subscribeTitle5",titleH5:"finance.PoSStaking"},
    "HASH_RATE":{title:"finance.subscribeTitle6",titleH5:"finance.HashrateMining"}
  };

  if(!Object.keys(CATEGORYS).includes(productType))
    return <></>

  const title = CATEGORYS[productType].title;
  const titleH5 = CATEGORYS[productType].titleH5;

  const renderHeaderLeft = ()=>{
    if(productType == "LAUNCH_POOL")
      return <div className={styles.headerLeft}>
        <img src={fund.getCurrencyIcon(currentProduct.currency.toLowerCase())}/>{currentProduct.currency.toUpperCase()+" "+t("finance.pool")}
      </div>
    return <div className={styles.headerLeft}>
      <img src={fund.getCurrencyIcon(currency.toLowerCase())}/>{productType == "HASH_RATE" ? finance.getProductNameHashRate(currentProduct) : t("finance.subscribe")+" "+currency}
    </div>
  }

  const renderHeaderLeftH5 = ()=>{
    return <div className={styles.headerLeft}>
      <img src={fund.getCurrencyIcon(currentProduct.currency.toLowerCase())}/>
      {productType == "HASH_RATE" ? finance.getProductNameHashRate(currentProduct) : currentProduct.currency.toUpperCase()+(productType == "LAUNCH_POOL" ? " "+t("finance.pool")+"-" : "-")+t(titleH5)}
    </div>
  }

  const renderLaunchPoolSelect = ()=>{
    return <div className={styles.poolSelectDiv}>
      <div className={styles.poolSelectTitle}>
        <p>{t("finance.pool")}</p>
        <p>{t("finance.subscribeEarn")} {interestCurrency}</p>
      </div>
      <div className={styles.poolSelect}>
        {financialProducts.map((item, index) => {
          if(item.productType != "LAUNCH_POOL" || item.interestCurrency != currentProduct.interestCurrency)
            return null;
          return <span className={item.id == currentProduct.id ? styles.selected : ""} style={getProductStatus(item).disabled ? { color: "rgba(0,0,0,0.4)" } : {}} onClick={() => {
            setCurrentProduct(item);
          }}>
            {item.currency.toUpperCase()}
            {item.systemTag == "HOT" ? <img className={styles.hot} src={hot} /> : null}
            {item.id == currentProduct.id ? <SvgIcon className={styles.gou} src={gou} style={{color:"var(--primary-color)"}}/> : null}
          </span>
        })}
      </div>
    </div>
  }

  const renderDuration = ()=>{
    if(financialProducts.length < 1)
      return <></>
    return <div className={styles.durationDiv}>
      <div className={styles.durationTitle}>
        <p>{t("finance.subscribeDuration")}</p>
        <p>{t("finance.subscribeEarn")} {interestCurrency}</p>
      </div>
      <DurationSelect financialProducts={financialProducts.filter((item)=>item.productType!="LAUNCH_POOL")} currentProduct={currentProduct} onChange={onChangeProduct} />
    </div>
  }

  const renderLaunchPoolInfo = ()=>{
    const r = (currentProduct.totalReward * currentProduct.rewardPercent / 100).toFixed(0);
    return <div className={styles.info4Div}>
      <div>
        <p>{t("finance.launchpoolTotal")}</p>
        <p>{r}</p>
        <p>{interestCurrency}</p>
      </div>
      <div>
        <p>{t("finance.launchpoolDaily")}</p>
        <p>{(r/currentProduct.duration).toFixed(r % currentProduct.duration ? 2 : 0)}</p>
        <p>{interestCurrency}</p>
      </div>
      <div>
        <p>{t("finance.launchpoolTime")}</p>
        <p>{currentProduct.duration} {t("day")}</p>
        <p>({stakingProgress(currentProduct)})</p>
      </div>
    </div>
  }

  const renderHashRateInfo = ()=>{
    const precision = fund.getCurrencyPrecision(interestCurrency);
    return <>
      {app.isH5 ? null : <div className={styles.info6Title}>
        <p>{t("finance.project")}</p>
        <p>{t("finance.subscribeEarn")} {interestCurrency}</p>
      </div>}
      <div className={styles.info6Div}>
        <div className={styles.info6Group}>
          <div>
            <XtFontScale>
              <p style={{minWidth:"max-content"}}>{new Big((1-currentProduct.managementFee/100)*currentProduct.dailyMinOutput / currentProduct.totalQuota).toFixed(precision)}-{new Big((1-currentProduct.managementFee/100)*currentProduct.dailyMaxOutput / currentProduct.totalQuota).toFixed(precision)} {interestCurrency}</p>
            </XtFontScale>
            <p style={{height:"0px"}}></p>
            <p>{t("finance.dailyPerShare")}</p>
          </div>
          <div>
            <p>{currentProduct.productPrice} {currency}</p>
            <p>{t("finance.perPrice")}</p>
          </div>
        </div>
        <div className={styles.info6Group}>
          <div>
            <p>{currentProduct.duration} {t("day")}</p>
            <p>{t("finance.launchpoolTime")}</p>
          </div>
          <div>
            <p>{currentProduct.managementFee} %</p>
            <p>{t("finance.hashrateFee")}</p>
          </div>
        </div>
      </div>
    </>
  }

  const setAmount = (v,isMax)=>{
    if(v == "")
    {
      setAmountValue("");
      if(productType == "HASH_RATE" && currentProduct.enableStaking)
        setAmountValue2("");
      setInputStatus(0);
      setInputTip("");
    }
    else
    {
      const b = new Big(fund.getBalanceByCurrencyName(currency));
      setAmountValue(v);
      if(productType == "HASH_RATE" && currentProduct.enableStaking)
        setAmountValue2(v*currentProduct.stakingPercent/100);
      if(productType == "HASH_RATE" && new Big(v*currentProduct.productPrice).gt(b))
      {
        setInputTip(t("WITHDRAW_011"));
        setInputStatus(1);
      }
      else if(productType != "HASH_RATE" && new Big(v).gt(b))
      {
        setInputTip(t("WITHDRAW_011"));
        setInputStatus(1);
      }
      else if(v > currentProduct.singleMax)
      {
        if(productType == "HASH_RATE")
          setInputTip(t("finance.inputSingleMax2")+" "+currentProduct.singleMax+" "+t("finance.unit"));
        else
          setInputTip(t("finance.inputSingleMax")+" "+currentProduct.singleMax+" "+currency);
        setInputStatus(2);
      }
      else if(memoLimit >= 0 && v > memoLimit)
      {
        if(productType == "HASH_RATE")
          setInputTip(t("finance.inputLimit2")+" "+memoLimit+" "+t("finance.unit"));
        else
          setInputTip(t("finance.inputLimit")+" "+memoLimit+" "+currency);
        setInputStatus(3);
      }
      else if(v < currentProduct.singleMin)
      {
        if(productType == "HASH_RATE")
          setInputTip(t("finance.inputSingleMin2")+" "+currentProduct.singleMin+" "+t("finance.unit"));
        else
          setInputTip(t("finance.inputSingleMin")+" "+currentProduct.singleMin+" "+currency);
        setInputStatus(4);
      }
      else
      {
        setInputTip("");
        setInputStatus(0);
      }
    }
  }
  
  const renderAmount = ()=>{
    return <div className={styles.amountDiv}>
      <div className={styles.amountTitle}>
        <p>{t(productType == "HASH_RATE" ? "finance.subscribeAmountUnit" : "finance.subscribeAmount")}</p>
        <a onClick={()=>{setStatus(-1)}} target="_blank">{t("finance.buchongCurrency",{currency})}</a>
      </div>
      <div className={styles.amountInputDiv+" "+(inputStatus>0 ? styles.amountInputDivError : "")}>
        <input value={amountValue} placeholder={t("finance.minimum") + " "+singleMin+" " + (productType == "HASH_RATE" ? t("finance.unit") : currency)} onChange={(e) => {
          var v = e.target.value;
          if(productType == "HASH_RATE")
            v = v.replace(/\./g,'');
          const l = v.split(".");
          if (v == "" || (!isNaN(v) && new Big(v).eq(new Big(v).toFixed(currencyPrecision)) && (l.length < 2 || l[1].length <= currencyPrecision)))
          {
            setAmount(v);
          }
        }} />
        <span>{productType == "HASH_RATE" ? t("finance.unit") : currency}</span>
        <a onClick={() => {
          var v = fund.getBalanceByCurrencyName(currency);
          const l = v.split(".");
          if (l.length == 2 && l[1].length > currencyPrecision)
          {
            v = l[0]+"."+l[1].substr(0,currencyPrecision);
          }
          if(productType == "HASH_RATE")
            v = Math.floor(v/currentProduct.productPrice);
          if(v > currentProduct.singleMax)
            v = currentProduct.singleMax;
          if(memoLimit >= 0 && v > memoLimit)
            v = memoLimit;
          setAmount(v,true);
        }}>{t("finance.maximum")}</a>
      </div>
      <p className={styles.amountInputTip}>{inputTip}</p>
      <div className={styles.amountBalanceDiv}>
        <p>
          {t("finance.availableAmount")}
          <span> {fund.getBalanceByCurrencyName(currency)} {currency}</span>
          <InfoTip content={t("finance.toolTipBalance")}></InfoTip>
        </p>
        <p>{t("finance.positionAmount")}<span> {position} {productType == "HASH_RATE" ? t("finance.unit") : currency}</span></p>
      </div>
      {productType == "HASH_RATE" && app.isH5 ? <div className={styles.amountTitle} style={{marginBottom:"20px"}}>
          <InfoTip content={t("finance.payAmountTip")}>
            <p className={styles.h5PayAmount}>{t("finance.payAmount")}</p>
          </InfoTip>
          <a className={styles.profitValue}>{new Big(amountValue || 0).times(currentProduct.productPrice).toString()} {currency}</a>
        </div> : null}
    </div>
  }

  const renderStakingAmount = ()=>{
    return <div className={styles.stakingDiv}>
      <div className={styles.stakingTitle}>
        <p>{t("finance.stakingAmount")}</p>
      </div>
      <div className={styles.stakingInputDiv}>
        <input value={amountValue2} disabled onChange={(e) => {
          const v = e.target.value;
          if (parseFloat(v) == v)
            setAmountValue2(v);
        }} />
        <span>{(currentProduct.stakingCurrency || "").toUpperCase()}</span>
      </div>
      <div className={styles.stakingBalanceDiv}>
        <p>{t("finance.availableAmount")}<span> {fund.getBalanceByCurrencyName(currentProduct.stakingCurrency)} {(currentProduct.stakingCurrency || "").toUpperCase()}</span></p>
      </div>
    </div>
  }

  const renderLimit = ()=>{
    return <div className={styles.limitDiv}>
      <div className={styles.limitGroup}>
        <div className={styles.limitTitle}>
          <p>{t("finance.limit")}</p>
        </div>
        <div className={styles.limitContent}>
          <p>{t("finance.limitMaximum")}{<span> {singleMax} {productType == "HASH_RATE" ? t("finance.unit") : currency}</span>}</p>
          {memoLimit < -0 ? <p>{t("finance.limitAvailable")}
            <span> {t("finance.nolimit")}</span>
            <InfoTip content={<span style={{fontSize:"12px" }} dangerouslySetInnerHTML={{__html:t("finance.toolTipLimit")}}></span>} maxWidth={280}></InfoTip>
          </p> : <p>{t("finance.limitAvailable")}{productType == "HASH_RATE" ? <span> {memoLimit} {t("finance.unit")}</span> : <span> {memoLimit} {currency}</span>}<InfoTip content={<span style={{fontSize:"12px" }} dangerouslySetInnerHTML={{__html:t("finance.toolTipLimit")}}></span>} maxWidth={280}></InfoTip></p>}
        </div>
      </div>
      {productType == "RUSH" || productType == "LAUNCH_POOL" || productType == "HASH_RATE" ? <div className={styles.limitGroup}>
        <div className={styles.limitTitle}>
          <p>{t(productType == "RUSH" ? "finance.limitTime1" : "finance.limitTime2")}</p>
        </div>
        {app.isH5 ? <div className={styles.limitContent}>
          <p>{t("console.manage.beginTime")}<span>{moment(productType == "RUSH" ? currentProduct.subscribeStartTime : currentProduct.workStartTime).format("YYYY-MM-DD HH:mm")}</span></p>
          <p>{t("console.manage.endTime")}<span>{moment(productType == "RUSH" ? currentProduct.subscribeEndTime : currentProduct.workEndTime).format("YYYY-MM-DD HH:mm")}</span></p>
        </div> : <div className={styles.limitContent}>
          <p><span>{moment(productType == "RUSH" ? currentProduct.subscribeStartTime : currentProduct.workStartTime).format("YYYY-MM-DD HH:mm")}</span> {t("finance.limitStart")}</p>
          <p><span>{moment(productType == "RUSH" ? currentProduct.subscribeEndTime : currentProduct.workEndTime).format("YYYY-MM-DD HH:mm")}</span> {t("finance.limitEnd")}</p>
        </div>}
      </div> : null}
    </div>
  }

  const renderProgress = ()=>{
    if(!(productType == "RUSH" || productType == "LAUNCH_POOL" || productType == "HASH_RATE"))
      return null;
    return <div className={styles.progressDiv}>
      <div className={styles.progressGroup}>
        <div className={styles.progressTitle}>
          <p>{t("finance.progressNow")}</p>
        </div>
        <div className={styles.progressContent}>
          <Progress percent={(100*subscribed/currentProduct.totalQuota).toFixed(2)} showInfo={!app.isH5}/>
          <p><span>{new Big(subscribed).toFixedCy()}</span>/{new Big(currentProduct.totalQuota).toFixedCy()} {productType == "HASH_RATE" ? t("finance.unit") : currency}<span className={styles.progressPercent}>{(100*subscribed/currentProduct.totalQuota).toFixed(2)}%</span></p>
        </div>
      </div>
      <div className={styles.progressGroup}>
        <div className={styles.progressTitle}>
          <p>{t(productType == "LAUNCH_POOL" ? (currentProduct.financeProductStatus === "MINING" || currentProduct.financeProductStatus === "ONGOING" ? "finance.miningEndsIn" : "finance.miningStartsIn") : "finance.progressEnd1")}</p>
        </div>
        <div className={styles.progressContent}>
          <Countdown data={productType == "LAUNCH_POOL" ? (currentProduct.financeProductStatus === "MINING" || currentProduct.financeProductStatus === "ONGOING"  ? currentProduct.workEndTime : currentProduct.workStartTime) : currentProduct.subscribeEndTime} />
        </div>
      </div>
    </div>
  }

  const renderAuto = ()=>{
    if(productType != "DEMAND_SAVING")
      return null;
    return <div className={styles.autoDiv}>
      <div className={styles.autoTitle}>
        <p>{t("finance.autoSubscribe")}</p>
        <AutoSubscribe financialProducts={financialProducts} currentProduct={currentProduct} onChange={(list,item)=>{
          setFinancialProducts(list);
          finance.showSubscribe.callback && finance.showSubscribe.callback(list);
          setCurrentProduct(item);
        }}/>
      </div>
      <p className={styles.autoContent}>
        {t("finance.autoTip")}
      </p>
    </div>
  }

  const renderInfo = (renderChild)=>{
    if(productType != "LAUNCH_POOL" && productType != "HASH_RATE")
      return null;
    const status = currentProduct.financeProductStatus == "PENDING" ? 5 : currentProduct.financeProductStatus == "PRE_SUBSCRIBING" ? 4 : currentProduct.financeProductStatus == "SUBSCRIBING" ? 1 : currentProduct.financeProductStatus == "ONGOING" ? 3 : 2;
    const ret = <div className={styles.infoDiv}>
      <div className={styles.infoStatus+" "+styles["infoStatus"+status]}>
        <SvgIcon src={StarSvg}/>
        <SvgIcon src={StarSvg}/>
        {t(status == 4 ? "finance.productStatus_PRE_SUBSCRIBING" : status == 1 ? "finance.productStatus_SUBSCRIBING" : status == 3 ? "finance.productStatus_MINING" : "finance.productStatus_PRE_SUBSCRIBING")}
      </div>
      <div className={styles.info1Div}>
        <img src={fund.getCurrencyIcon(interestCurrency.toLowerCase())}/>
        <p>{interestCurrency}</p>
        <p>
          <span>{t("finance.price")}</span>
          <span>{new Big(fund.getCoinValue(10000000,interestCurrency.toLowerCase())/fund.getCoinValue(10000000,"usdt")).toFixed(fund.getCurrencyPrecision("usdt"))} USDT</span>
        </p>
      </div>
      {currentProduct.whitePaperSite || currentProduct.officialSite || currentProduct.regulationSite ? <div className={styles.info2Div}>
        {productType == "LAUNCH_POOL" && currentProduct.whitePaperSite ? <a href={currentProduct.whitePaperSite}>
          <SvgIcon src={WhitepaperSvg}/>{t("finance.whitepaper")}
        </a> : null}
        {currentProduct.officialSite ? <a href={currentProduct.officialSite}>
          <SvgIcon src={WebsiteSvg}/>{t("finance.website")}
        </a> : null}
        {currentProduct.regulationSite ? <a href={currentProduct.regulationSite}>
          <SvgIcon src={RulesSvg}/>{t("finance.rules")}
        </a> : null}
      </div> : null}
      {renderChild && renderChild()}
    </div>
    if(productType == "HASH_RATE")
      return <>
        <div className={styles.info6Title}>
          <p>{t("finance.project")}</p>
          <p>{t("finance.subscribeEarn")} {interestCurrency}</p>
        </div>
        {ret}
      </>
    return ret;
  }

  const getYearlyProfit = ()=>{
    if(productType == "LAUNCH_POOL")
    {
      return finance.getYearlyProfitLaunchPool(currentProduct, subscribed, amountValue == '' ? 0 : parseFloat(amountValue));
    }
    else if(productType == "HASH_RATE")
    {
      return finance.getYearlyProfitHashRate(currentProduct);
    }
    else if(currentProduct.profitType == "GRADING" && currentProduct.apyList && currentProduct.apyList.length > 1)
    {
      var min = currentProduct.apyList[0].annualized || 0;
      var max = currentProduct.apyList[0].annualized || 0;
      for(var i=0;i<currentProduct.apyList.length;++i)
      {
        var a = currentProduct.apyList[i].annualized || 0;
        if(a < min)
          min = a;
        if(a > max)
          max = a;
      }
      return min.toFixed(2)+"% ~ "+max.toFixed(2)+"%";
    }
    else if(currentProduct.apyList)
    {
      return (currentProduct.apyList[0].annualized || 0).toFixed(2)+"%";
    }
    return "--%";
  }

  const renderProfit = ()=>{
    const mode = (productType == "DEMAND_SAVING" || currentProduct.interestReinvest) ? 2 : 1;
    return <div className={styles.profitDiv}>
      <div className={styles.profitTitle}>
        <p>{t("finance.profitTitle")}</p>
      </div>
      <div className={styles.profitContainer}>
        {currentProduct.profitType == "GRADING" && currentProduct.apyList && currentProduct.apyList.length ? <div className={styles.profitGrading}>
          <div>{t("finance.tagTier")}</div>
          {currentProduct.apyList.map((item, index) => {
            var light = index == 0 || position + parseFloat(amountValue || '0') > currentProduct.apyList[index - 1].level;
            return <p className={light ? styles.light : ""}>
              {light ? <i>
                <SvgIcon src={checkSvg} style={{color:app.isH5 ? "#fff" : "#222"}} colorStroke/>
              </i> : <img src={app.isH5 ? check3 : check2} />}
              {t("finance.tier") + " " + (index + 1) + ": " + (item.level && item.level > 0 ? (index == 0 ? 0 : currentProduct.apyList[index - 1].level) + " - " + item.level : (index == 0 ? ">0" : "> " + currentProduct.apyList[index - 1].level)) + " " + (currency || "").toUpperCase()}
              <span>{Big(item.annualized || 0).toFixed(2) + "%"}</span>
            </p>
          })}
        </div> : null}
        {productType == "HASH_RATE" ? !app.isH5 && <p className={styles.profitP}>
          <InfoTip content={t("finance.payAmountTip")}>
            <a style={{ color: "rgba(0, 0, 0, 0.6)" }}>{t("finance.payAmount")}</a>
          </InfoTip>
          <span className={styles.profitValue}>{new Big(amountValue || 0).times(currentProduct.productPrice).toString()} {currency}</span>
        </p> : <p className={styles.profitP}>
          {productType == "LAUNCH_POOL" || productType == "HASH_RATE" ? <InfoTip content={t("finance.profitYearlyTip")}>
            <a style={{ color: "rgba(0, 0, 0, 0.6)" }}>{t("finance.profitYearly")}</a>
          </InfoTip> : <span>{t("finance.profitYearly")}</span>}
          <span className={styles.profitValue}>{getYearlyProfit()}</span>
        </p>}
        {productType == "HASH_RATE" && currentProduct.enableStaking ? <p className={styles.profitP}>
          <span>{t("finance.stakingAmount")}</span>
          <span>{amountValue2} {(currentProduct.stakingCurrency || "").toUpperCase()}</span>
        </p> : null}
        <p className={styles.profitP}>
          <span>{t("finance.profitMode")}</span>
          <InfoTip content={t("finance.profitMode" + mode + "Tip")}>
            <a>{t("finance.profitMode" + mode)}</a>
          </InfoTip>
        </p>
        {productType == "HASH_RATE" ? <p className={styles.profitP}>
          <span>{t("finance.dailyProfit")}</span>
          <span>{memoExpectProfit} {interestCurrency}</span>
        </p> : <p className={styles.profitP}>
          {productType == "LAUNCH_POOL" ? <InfoTip content={t("finance.profitExpect3Tip")}>
            <a style={{ color: "rgba(0, 0, 0, 0.6)" }}>{t("finance.profitExpect3")}</a>
          </InfoTip> : <span>{t(productType == "DEMAND_SAVING" ? "finance.profitExpect1" : "finance.profitExpect2")}</span>}
          <span className={styles.profitValue}>{memoExpectProfit} {interestCurrency}</span>
        </p>}
      </div>
    </div>
  }
  
  const renderTime = ()=>{
    return <div className={styles.timeDiv}>
      <div className={styles.timeTitle}>
        <p>{t("finance.timeTitle")}</p>
      </div>
      <div className={styles.timeContainer}>
        <div>
          <p>{t("finance.time1")}</p>
          <p>{t("finance.timeNow")}</p>
        </div>
        <div>
          <p>{t("finance.time2")}</p>
          <p>{memoTimes.time2}</p>
        </div>
        <div>
          <p>{t("finance.time3")}</p>
          <p>{memoTimes.time3}</p>
        </div>
        {productType != "DEMAND_SAVING" ? <div>
          <p>{t("finance.time4")}</p>
          <p>{memoTimes.time4}</p>
        </div> : null}
        {productType != "DEMAND_SAVING" && productType != "HASH_RATE" ? <div>
          <p>{t("finance.time5")}</p>
          <p>{memoTimes.time5}</p>
        </div> : null}
      </div>
    </div>
  }

  const renderBtn = ()=>{
    return <div className={styles.btnDiv}>
      <div className={styles.checkDiv}>
        <Checkbox checked={protocolChecked} onChange={(e) => { setProtocolChecked(e.target.checked) }}></Checkbox>
        <Trans i18nKey={"finance.checkProtocol"} components={{
          1: <span style={{ color: "var(--primary-color)", cursor: "pointer" }} onClick={() => {
            var url = "https://spikex.zendesk.com/hc/en-us/articles/24740531948953";
            var langPath = XtLocale.getLangPath();
            if(langPath == "zh-CN" || langPath == "zh-HK")
              url = "https://spikex.zendesk.com/hc/zh-cn/articles/24740531948953";
            window.open(url);
          }}></span>,
        }}></Trans>
      </div>
      <p className={styles.confirmBtn + " " + (btnActive() ? styles.atv : "")} onClick={() => {
        if (btnActive()) {
          if (currentProduct.noviceExclusive && !finance.isNewer) {
            return message.warn(t("finance.productDisabled_newer"));
          }
          var p = {
            type: "SUBSCRIBE",
            amount: amountValue,
            bizId: new Date().getTime(),
            currency: currentProduct.currency,
            productId: currentProduct.id
          };
          if (productType == "HASH_RATE") {
            p.amount = new Big(p.amount).times(currentProduct.productPrice).toString();
            if (currentProduct.enableStaking) {
              p.stakingAmount = amountValue2;
              p.stakingCurrency = currentProduct.stakingCurrency;
            }
          }
          setBtnPosting(true);
          post_order(p).then((data) => {
            const orderId = data;
            finance.getAssets();
            get_product_by_id({
              params: {
                productId: currentProduct.id
              }
            }).then((product) => {
              finance.setIsNewer(false);
              setBtnPosting(false);
              setCurrentProduct(product);
              if (financialProducts) {
                var list = [];
                for (var i in financialProducts) {
                  var item = financialProducts[i];
                  if (item.id == product.id)
                    list.push(product);
                  else
                    list.push(item);
                }
                setFinancialProducts(list);
                finance.showSubscribe.callback && finance.showSubscribe.callback(list);
              }
            }).catch(() => {
              setBtnPosting(false);
            });
            setStatus(amountValue);
            setShowStakingAmount(amountValue2);
            setPostTime(new Date().getTime());
          }).catch(() => {
            setBtnPosting(false);
          });
        }
      }}>{t("finance.confirm")}</p>
    </div>
  }

  const btnActive = ()=>{
    if(btnPosting)
      return false;
    if(productType == "RUSH")
    {
      var t = new Date().getTime();
      if(t < currentProduct.subscribeStartTime || t > currentProduct.subscribeEndTime)
        return false;
    }
    return inputStatus == 0 && amountValue > 0 && (memoLimit < 0 || amountValue <= memoLimit) && protocolChecked && !getProductStatus(currentProduct).disabled;
  }

  const closeModal = ()=>{
    finance.showSubscribe = null;
    setFinancialProducts([]);
    setCurrentProduct(null);
    setStatus(0);
    message.destroy();
  }

  const stakingProgress = (product) => {
    const { duration, workStartTime } = product;
    let dist = moment().diff(moment(workStartTime), "days");
    dist < 0 && (dist = 0);
    dist > duration && (dist = duration);
    return dist + "/" + duration;
  };

  if(status == -1 && !app.isH5)
    return (<Modal wrapClassName={styles.modalBuyCoin} open={true} width={window.innerWidth < 582 ? window.innerWidth - 20 : 562} centered={true} maskClosable={false} title={
      <div className={styles.headerDiv}>
        <p className={styles.headerTitle}>{t("finance.buchongCurrency",{currency})}</p>
        <img className={styles.closeIcon} src={closePng} onClick={() => setStatus(0)} />
      </div>
    } closeIcon={false} footer={null} >
      <div className={styles.channelDiv} onClick={()=>{
          window.open(getUrl("/wallet/account/common/deposit"));
        }}>
        <i className={styles.channelIcon}><SvgIcon src={buy1Svg} style={{color:"var(--primary-color)"}} colorNoChange/></i>
        <div className={styles.channelInfo}>
          <p className={styles.channelInfoTitle}>{t("home.deposit")}</p>
          <p className={styles.channelInfoContent}>{t("finance.buchongDeposit")}</p>
        </div>
        <span className={styles.channelArrow}>
          <SvgIcon src={ArrowSvg} style={{width:"16px",height:"11px"}}/>
        </span>
      </div>
      <div className={styles.channelDiv} onClick={()=>{
          window.open(getUrl("/otc/index"));
        }}>
        <i className={styles.channelIcon}><SvgIcon src={buy2Svg} style={{color:"var(--primary-color)"}} colorNoChange/></i>
        <div className={styles.channelInfo}>
          <p className={styles.channelInfoTitle}>{t("finance.buyCrypto")}</p>
          <p className={styles.channelInfoContent}>{t("finance.buchongBuy")}</p>
        </div>
        <span className={styles.channelArrow}>
          <SvgIcon src={ArrowSvg} style={{width:"16px",height:"11px"}}/>
        </span>
      </div>
      <div className={styles.channelDiv} onClick={()=>{
          window.open(getUrl(currency == "USDT" ? "/trade/btc_usdt" : "/trade/"+currency.toLowerCase()+"_usdt"));
        }}>
        <i className={styles.channelIcon}><SvgIcon src={buy3Svg} style={{color:"var(--primary-color)"}} colorNoChange/></i>
        <div className={styles.channelInfo}>
          <p className={styles.channelInfoTitle}>{t("home.TRADE")}</p>
          <p className={styles.channelInfoContent}>{t("finance.buchongTrade")}</p>
        </div>
        <span className={styles.channelArrow}>
          <SvgIcon src={ArrowSvg} style={{width:"16px",height:"11px"}}/>
        </span>
      </div>
    </Modal>);
  if(status > 0)
  {
    const mode = (productType == "DEMAND_SAVING" || currentProduct.interestReinvest) ? 2 : 1;
    return (
      <Modal wrapClassName={styles.modalSubscribeOK} open={true} width={window.innerWidth < 480 ? window.innerWidth - 20 : 460} centered={true} maskClosable={false} title={
        <div className={styles.headerDiv}>
          <p className={styles.headerTitle}>{t("finance.subscribeOK")}</p>
          <img className={styles.closeIcon} src={closePng} onClick={() => closeModal() } />
        </div>
      } closeIcon={false} footer={null} >
        <img className={styles.subokImg} src={subok} />
        <div className={styles.infoDiv}>
          {productType == "HASH_RATE" ? <div>
            <p>{t("finance.subscribeAmountUnit")}</p>
            <p style={{color:"var(--primary-color)"}}>{parseFloat(status)} {t("finance.unit")}</p>
          </div> : null}
          <div>
            <p>{t("finance.subscribeAmount")}</p>
            <p style={{color:"var(--primary-color)"}}>{productType == "HASH_RATE" ? status*currentProduct.productPrice : status} {currency}</p>
          </div>
          {productType == "HASH_RATE" && showStakingAmount ? <div>
            <p>{t("finance.stakingAmount")}</p>
            <p>{showStakingAmount} {(currentProduct.stakingCurrency || "").toUpperCase()}</p>
          </div> : null}
          <div>
            <p>{t("finance.productType")}</p>
            <p>{t(title)}</p>
          </div>
          {productType == "TIME_SAVING" || productType == "RUSH" || productType == "POS_STAKING" || productType == "HASH_RATE" ? <div>
            <p>{t("finance.productDuration")}</p>
            <p>{currentProduct.duration+ " " + t("finance.days")}</p>
          </div> : null}
          <div>
            <p>{t("finance.profitMode")}</p>
            <p>{t("finance.profitMode"+mode)}</p>
          </div>
          <div>
            <p>{t("finance.launchpoolCoin")}</p>
            <p>{interestCurrency}</p>
          </div>
          {productType == "LAUNCH_POOL" ? <div>
            <p>{t("finance.stakingProgress")}</p>
            <p>{stakingProgress(currentProduct)}</p>
          </div> : productType == "HASH_RATE" ? null : <div>
            <p>{t("finance.profitYearly")}</p>
            <p>{getYearlyProfit()}</p>
          </div>}
        </div>
        <div className={styles.timeDiv}>
          <div>
            <p>{t("finance.time1")}</p>
            <p>{moment(postTime).format("YYYY-MM-DD HH:mm:ss")}</p>
          </div>
          <div>
            <p>{t("finance.time2")}</p>
            <p>{memoTimes.time2}</p>
          </div>
          <div>
            <p>{t("finance.time3")}</p>
            <p>{memoTimes.time3}</p>
          </div>
          {productType != "DEMAND_SAVING" ? <div>
            <p>{t("finance.time4")}</p>
            <p>{memoTimes.time4}</p>
          </div> : null}
          {productType != "DEMAND_SAVING" && productType != "HASH_RATE" ? <div>
            <p>{t("finance.time5")}</p>
            <p>{memoTimes.time5}</p>
          </div> : null}
        </div>
        <div className={styles.btnDiv}>
          <p onClick={() => {
            location.href = getUrl("/wallet/account/finance");
          }}>{t("finance.goOrder")}</p>
          <p onClick={() => {
            if (currentProduct.noviceExclusive && !finance.isNewer) {
              closeModal();
            }
            else
              setStatus(0);
          }}>{t("finance.continueSubscribe")}</p>
        </div>
      </Modal>
    );
  }
  const renderBodyLeft = ()=>{ 
    return <div className={styles.bodyLeft}>
      {productType == "LAUNCH_POOL" ? renderLaunchPoolSelect() : null}
      {productType == "LAUNCH_POOL" ? renderLaunchPoolInfo() : productType == "HASH_RATE" ? renderHashRateInfo() : renderDuration()}
      {renderAmount()}
      {productType == "HASH_RATE" && currentProduct.enableStaking ? renderStakingAmount() : null}
      {renderLimit()}
      {productType == "RUSH" || productType == "LAUNCH_POOL" || productType == "HASH_RATE" ? renderProgress() : null}
      {productType == "DEMAND_SAVING" ? renderAuto() : null}
    </div>;
  }
  const renderBodyRight = ()=>{
    return <div className={styles.bodyRight}>
      {productType == "LAUNCH_POOL" || productType == "HASH_RATE" ? renderInfo() : null}
      {renderProfit()}
      {renderTime()}
      {renderBtn()}
    </div>;
  }
  const renderBodyH5 = ()=>{
    return <div className={styles.bodyH5}>
      {productType == "LAUNCH_POOL" ? renderLaunchPoolSelect() : null}
      {productType == "LAUNCH_POOL" ? renderInfo(renderLaunchPoolInfo) : productType == "HASH_RATE" ? renderInfo(renderHashRateInfo) : renderDuration()}
      {renderAmount()}
      {productType == "HASH_RATE" && currentProduct.enableStaking ? renderStakingAmount() : null}
      {renderLimit()}
      {productType == "RUSH" || productType == "LAUNCH_POOL" || productType == "HASH_RATE" ? renderProgress() : null}
      {renderProfit()}
      {productType == "DEMAND_SAVING" ? renderAuto() : null}
      {renderTime()}
      {renderBtn()}
    </div>;
  }
  return (app.isH5 ? <Drawer className={styles.modalSubscribe} placement="bottom" open={showDrawer} width="100vw" height="100vh" centered={true} maskClosable={false} title={
    <div className={styles.headerDiv}>
      {renderHeaderLeftH5()}
      <img className={styles.closeIcon} src={closePng} onClick={() => {
        setShowDrawer(false);
      }}/>
    </div>
  } closeIcon={false} footer={null} afterOpenChange={(open)=>{
    if(!open)
    {
      finance.showSubscribe = null;
      setFinancialProducts([]);
      setCurrentProduct(null);
      setStatus(0);
      setShowDrawer(true);
      message.destroy();
    }
  }}>
    {renderBodyH5()}
    <Drawer className={styles.modalBuyCoin} placement="bottom" open={status==-1} width="100vw" height="346" centered={true} maskClosable={true} title={
        <div className={styles.headerDiv}>
          <p className={styles.headerTitle}>{t("finance.buchongCurrency",{currency})}</p>
          <img className={styles.closeIcon} src={closePng} onClick={() => {
            setStatus(0);
          }} />
        </div>
      } closeIcon={false} footer={null} onClose={() => {
        setStatus(0);
      }}>
        <div className={styles.channelDiv} onClick={()=>{
          window.open(getUrl("/wallet/account/common/deposit"));
        }}>
        <i className={styles.channelIcon}><SvgIcon src={buy1Svg} style={{color:"var(--primary-color)"}} colorNoChange/></i>
        <div className={styles.channelInfo}>
          <p className={styles.channelInfoTitle}>{t("home.deposit")}</p>
          <p className={styles.channelInfoContent}>{t("finance.buchongDeposit")}</p>
        </div>
        <span className={styles.channelArrow}>
          <SvgIcon src={ArrowSvg} style={{width:"16px",height:"11px"}}/>
        </span>
      </div>
      <div className={styles.channelDiv} onClick={()=>{
          window.open(getUrl("/otc/index"));
        }}>
        <i className={styles.channelIcon}><SvgIcon src={buy2Svg} style={{color:"var(--primary-color)"}} colorNoChange/></i>
        <div className={styles.channelInfo}>
          <p className={styles.channelInfoTitle}>{t("finance.buyCrypto")}</p>
          <p className={styles.channelInfoContent}>{t("finance.buchongBuy")}</p>
        </div>
        <span className={styles.channelArrow}>
          <SvgIcon src={ArrowSvg} style={{width:"16px",height:"11px"}}/>
        </span>
      </div>
      <div className={styles.channelDiv} onClick={()=>{
          window.open(getUrl(currency == "USDT" ? "/trade/btc_usdt" : "/trade/"+currency.toLowerCase()+"_usdt"));
        }}>
        <i className={styles.channelIcon}><SvgIcon src={buy3Svg} style={{color:"var(--primary-color)"}} colorNoChange/></i>
        <div className={styles.channelInfo}>
          <p className={styles.channelInfoTitle}>{t("home.TRADE")}</p>
          <p className={styles.channelInfoContent}>{t("finance.buchongTrade")}</p>
        </div>
        <span className={styles.channelArrow}>
          <SvgIcon src={ArrowSvg} style={{width:"16px",height:"11px"}}/>
        </span>
      </div>
    </Drawer>
  </Drawer> : <Modal wrapClassName={styles.modalSubscribe} open={true} width={window.innerWidth < 831 ? window.innerWidth - 20 : 811} centered={true} maskClosable={false} title={
      <div className={styles.headerDiv}>
        {renderHeaderLeft()}
        <p className={styles.headerTitle}>{t(title)}</p>
        <img className={styles.closeIcon} src={closePng} onClick={() => { closeModal() }}/>
      </div>
    } closeIcon={false} footer={null} >
      {renderBodyLeft()}
      {renderBodyRight()}
    </Modal>
  );
});